import { useRef, useEffect } from 'react';
import { StyledDataTokenPopoverWrapper, StyledIndicatorTopArrowWrapper, StyledIndicatorTopArrow, StyledIndicatorArrowBottomWrapper, StyledIndicatorBottomArrow } from 'automation-ui-formula-editor/data-passing-panel/Inputs/DataPropertyPopoverMenu/DataTokenStyle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PLACEMENTS = {
  TOP: 'top',
  BOTTOM: 'bottom'
};
const DataTokenPopoverWrapper = ({
  children,
  dataTokenRef,
  onClose,
  verticalPlacementBuffer = 300
}) => {
  const dataTokenPopoverRef = useRef(null);
  const clickHandlerRef = useRef(null);

  // DEV NOTE: Make sure if this component unmounts we unbind our click handler
  useEffect(() => {
    clickHandlerRef.current = handleMouseUpEvent;
    return function () {
      if (clickHandlerRef.current) {
        document.removeEventListener('click', clickHandlerRef.current);
        clickHandlerRef.current = null;
      }
      onClose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // DEV NOTE: setup the click listener so if the user clicks outside this popover call onClose to clean it up
  useEffect(() => {
    if (clickHandlerRef.current) {
      document.removeEventListener('click', clickHandlerRef.current);
    }
    clickHandlerRef.current = handleMouseUpEvent;
    document.addEventListener('click', clickHandlerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTokenRef]);
  function handleMouseUpEvent(event) {
    if (!(dataTokenRef !== null && dataTokenRef !== void 0 && dataTokenRef.current) || dataTokenRef.current.contains(event.target) || isTargetClassInRef(event.target, dataTokenRef.current) || !(dataTokenPopoverRef !== null && dataTokenPopoverRef !== void 0 && dataTokenPopoverRef.current) || dataTokenPopoverRef.current.contains(event.target)) {
      return;
    }
    onClose();
  }
  if (!dataTokenRef || typeof !dataTokenRef === 'string' || !dataTokenRef.current) {
    return null;
  }

  // get the window dimensions so we can determine if we should render above OR below the tag
  const windowHeight = window.innerHeight;
  const position = dataTokenRef.current.getBoundingClientRect();
  const leftPosition = position.left + 20;
  let placement = PLACEMENTS.TOP;
  let positionCSS;
  if (position.top + verticalPlacementBuffer <= windowHeight) {
    const topPosition = position.top + position.height + 15;
    positionCSS = {
      top: `${topPosition}px`,
      left: `${leftPosition}px`
    };
  }
  if (position.top + verticalPlacementBuffer > windowHeight) {
    placement = PLACEMENTS.BOTTOM;
    const bottomPosition = windowHeight - position.bottom + position.height + 15;
    positionCSS = {
      bottom: `${bottomPosition}px`,
      left: `${leftPosition}px`
    };
  }
  return /*#__PURE__*/_jsxs(StyledDataTokenPopoverWrapper, {
    style: positionCSS,
    ref: dataTokenPopoverRef,
    "data-panel-blur-ignore": "true",
    "data-test-id": "data-token-popover-wrapper",
    children: [placement === PLACEMENTS.TOP && /*#__PURE__*/_jsx(StyledIndicatorTopArrowWrapper, {
      "data-test-id": "data-token-popover-indicator-top",
      children: /*#__PURE__*/_jsx(StyledIndicatorTopArrow, {
        children: "\xA0"
      })
    }), children, placement === PLACEMENTS.BOTTOM && /*#__PURE__*/_jsx(StyledIndicatorArrowBottomWrapper, {
      "data-test-id": "data-token-popover-indicator-bottom",
      children: /*#__PURE__*/_jsx(StyledIndicatorBottomArrow, {
        children: "\xA0"
      })
    })]
  });
};

// Due to the trellis migration rewriting classNames on the fly we need to check if any of the classNames are in the ref
function isTargetClassInRef(target, ref) {
  // Check if target has classList
  const targetElement = target;
  if (!targetElement.classList) return false;

  // Get all elements within ref
  const refElements = ref.getElementsByTagName('*');

  // Convert target's classList to array
  const targetClasses = Array.from(targetElement.classList);

  // Check each element in ref
  for (const refElement of Array.from(refElements)) {
    const refClasses = Array.from(refElement.classList);
    // Check if any class matches
    if (targetClasses.some(className => refClasses.includes(className))) {
      return true;
    }
  }
  return false;
}
export default DataTokenPopoverWrapper;